/**
 * Working-day offsets for the standard (STD/ODR/SPR) timeline calculator.
 * Negative values are before the anchor date; positive values are after.
 */
/*Start*/
export const TIMELINE_OFFSETS = {
  // Relative to fieldwork start date
  KICK_OFF_CALL_FROM_START: -50,
  RISK_ASSESSMENT_FROM_START: -40,
  PLANNING_CALL_ENGAGEMENT_LETTER_FROM_START: -15,
  DOCUMENTATION_RECEIVED_FROM_START: -5,
  INTERIM_MEETING_OPS_LEAD_FROM_START: 5,
  // Relative to fieldwork end date
  PRE_CLOSING_MEETING_FROM_END: 5,
  DRAFT_REPORT_MGMT_RESPONSE_FROM_END: 15,
  CLOSING_MEETING_FROM_END: 22,
} as const;
/*End*/

/**
 * Working-day offsets used outside the GLRR timeline builder
 * (getters, silent recalculation, and schedule payload assembly).
 * Negative values are before Go-Live; positive values are after.
 */
export const GLRR_FIELD_CONFIG = {
  /** glrrInterimCallDate getter and GLRRInterimCallDate payload field. */
  INTERIM_CALL_FROM_GO_LIVE: -20,
  /** Pre Go-Live fieldwork start date (Pre+Post layout only). */
  PRE_FW_START_FROM_GO_LIVE: -55,
  /** Pre Go-Live fieldwork end date (Pre+Post layout only). */
  PRE_FW_END_FROM_GO_LIVE: -20,
  /** Post Go-Live fieldwork start date. */
  POST_FW_START_FROM_GO_LIVE: 10,
} as const;

/** Working days added to fieldwork end date to compute Target Publication Date. */
export const TARGET_PUB_WORKING_DAYS_MULTI = 45;
export const TARGET_PUB_WORKING_DAYS_SINGLE = 30;

/**
 * Working-day offsets for the GLRR (Go-Live) timeline calculator.
 * Negative values are before the anchor date; positive values are after.
 */
/*Start*/
export const GLRR_TIMELINE_OFFSETS = {
  // Relative to Go-Live date
  IDENTIFY_PROJECTS_FROM_GO_LIVE: -90,
  INFO_GATHERING_MOB_TEAM_FROM_GO_LIVE: -75,
  IDENTIFY_PROJECTS_WAVE_FROM_GO_LIVE: -65,
  KICK_OFF_CALL_FROM_GO_LIVE: -60,
  OBTAIN_PROCESS_DOCS_FROM_GO_LIVE: -50,
  INTERIM_MEETING_FROM_GO_LIVE: -20,
  REMEDIATE_REP_LETTER_FROM_GO_LIVE: -10,
  POST_GO_LIVE_TESTING_START_FROM_GO_LIVE: 10,
  POST_GO_LIVE_TESTING_END_FROM_GO_LIVE: 30,
  // Relative to Post Go-Live fieldwork end date
  CLOSING_MEETING_FROM_POST_END: 19,
  PROJECT_ACTION_PLANS_RECEIVED_FROM_POST_END: 21,
  DRAFT_REPORT_MANAGER_REVIEW_FROM_POST_END: 26,
  DRAFT_REPORT_GLOBAL_LEAD_REVIEW_FROM_POST_END: 27,
} as const;
/*End*/
